export const HomeTabData = {
  // hot: [
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "FC",
  //     name: "NCVIP Super Elements",
  //     platFormCode: "FC",
  //     gameType: "SLOT",
  //     casinoType: "FC-SLOT-033",
  //     src: "/assets/HotGames/darkIcon.webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "PP",
  //     gameType: "SLOT",
  //     platFormCode: "PP",
  //     casinoType: "PP-SLOT-411",
  //     name: "NCVIP Gates of Olympus 1000",
  //     src: "/assets/HotGames/darkIcon (1).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "JILI",
  //     name: "Lucky Jaguar 500",
  //     platFormCode: "JILI",
  //     gameType: "SLOT",
  //     casinoType: "JILI-SLOT-115",
  //     src: "/assets/HotGames/darkIcon (2).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 2,
  //     vendorCode: "PP",
  //     gameType: "LIVE",
  //     casinoType: "PP-LIVE-190",
  //     name: "24D Spin",
  //     platFormCode: "PP",
  //     src: "/assets/HotGames/darkIcon (3).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "JILI",
  //     platFormCode: "JILI",
  //     gameType: "SLOT",
  //     casinoType: "JILI-SLOT-142",
  //     name: "Super Ace Speed Exclusive",
  //     src: "/assets/HotGames/darkIcon (4).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "PP",
  //     gameType: "SLOT",
  //     casinoType: "PP-SLOT-598",
  //     name: "Fortune Ace Super Scatter",
  //     platFormCode: "PP",
  //     src: "/assets/HotGames/darkIcon (5).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 8192,
  //     vendorCode: "JILI",
  //     name: "Crash Aviator",
  //     platFormCode: "SPRIBE",
  //     gameType: "EGAME",
  //     casinoType: "SPRIBE-EGAME-001",
  //     src: "/assets/HotGames/darkIcon (6).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "JILI",
  //     name: "Fortune Gems 500",
  //     platFormCode: "JILI",
  //     gameType: "SLOT",
  //     casinoType: "JILI-SLOT-043",
  //     src: "/assets/HotGames/darkIcon (7).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "JILI",
  //     name: "Money Coming",
  //     platFormCode: "JILI",
  //     gameType: "SLOT",
  //     casinoType: "JILI-SLOT-029",
  //     src: "/assets/HotGames/darkIcon (8).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "PG",
  //     platFormCode: "PG",
  //     gameType: "SLOT",
  //     casinoType: "PG-SLOT-105",
  //     name: "Wild Bounty Showdown",
  //     src: "/assets/HotGames/darkIcon (9).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "PG",
  //     platFormCode: "PG",
  //     gameType: "SLOT",
  //     casinoType: "PG-SLOT-058",
  //     name: "Treasures of Aztec",
  //     src: "/assets/HotGames/darkIcon (10).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "PG",
  //     name: "Anubis Wrath",
  //     platFormCode: "PG",
  //     gameType: "SLOT",
  //     casinoType: "PG-SLOT-138",
  //     src: "/assets/HotGames/darkIcon (11).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "JILI",
  //     name: "Super Ace",
  //     platFormCode: "JILI",
  //     gameType: "SLOT",
  //     casinoType: "JILI-SLOT-027",
  //     src: "/assets/HotGames/darkIcon (12).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "JILI",
  //     name: "Super Ace Deluxe",
  //     platFormCode: "JILI",
  //     gameType: "SLOT",
  //     casinoType: "JILI-SLOT-102",
  //     src: "/assets/HotGames/darkIcon (13).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "JILI",
  //     name: "Circus Joker 4096",
  //     platFormCode: "JILI",
  //     gameType: "SLOT",
  //     casinoType: "JILI-SLOT-136",
  //     src: "/assets/HotGames/darkIcon (14).webp",
  //   },

  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "JDB",
  //     platFormCode: "JDB",
  //     gameType: "SLOT",
  //     casinoType: "JDB-SLOT-127",
  //     name: "Magic Ace WILD LOCK",
  //     src: "/assets/HotGames/darkIcon (15).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1,
  //     vendorCode: "FC",
  //     platFormCode: "FC",
  //     gameType: "SLOT",
  //     casinoType: "FC-SLOT-028",
  //     name: "GOLDEN GENIE",
  //     src: "/assets/HotGames/darkIcon (16).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1024,
  //     vendorCode: "JILI",
  //     name: "Frog Dash",
  //     platFormCode: "JILI",
  //     gameType: "TABLE",
  //     casinoType: "JILI-TABLE-088",
  //     src: "/assets/HotGames/darkIcon (17).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 1024,
  //     vendorCode: "JILI",
  //     platFormCode: "JILI",
  //     gameType: "TABLE",
  //     casinoType: "JILI-TABLE-082",
  //     name: "Chicken Dash 10000",
  //     src: "/assets/HotGames/darkIcon (18).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 2,
  //     vendorCode: "EVOLUTION",
  //     name: "Crazy Time",
  //     platFormCode: "EVOLUTION",
  //     gameType: "LIVE",
  //     casinoType: "EVOLUTION-LIVE-006",
  //     src: "/assets/HotGames/darkIcon (19).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 2,
  //     vendorCode: "SEXYBCRT",
  //     platFormCode: "SEXYBCRT",
  //     gameType: "LIVE",
  //     casinoType: "MX-LIVE-001",
  //     name: "Baccarat Classic",
  //     src: "/assets/HotGames/darkIcon (20).webp",
  //   },
  //   {
  //     categoryType: "GAME",
  //     gameType: 2,
  //     vendorCode: "PP",
  //     gameType: "LIVE",
  //     casinoType: "PP-LIVE-188",
  //     name: "Money Time",
  //     platFormCode: "PP",
  //     src: "/assets/HotGames/darkIcon (21).webp",
  //   },
  // ],
  hot: [
    {
      name: "HEYVIP Super Ace",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-027",
      src: "/assets/HotGames/56091.png",
    },
    {
      name: "Fortune Garuda 1000",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-225",
      src: "/assets/HotGames/59547.png?v=1789713128023",
    },
    {
      name: "Super Ace",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-027",
      src: "/assets/HotGames/27744.webp?v=1789713128031",
    },
    {
      name: "Fortune Garuda 500",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-193",
      src: "/assets/HotGames/54001.png?v=1789713128032",
    },
    {
      name: "Super Ace Deluxe",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-102",
      src: "/assets/HotGames/27748.webp?v=1789713128032",
    },
    {
      name: "Boxing King",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-031",
      src: "/assets/HotGames/27745.webp?v=1789713128032",
    },
    {
      name: "Fortune Gems 500",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-138",
      src: "/assets/HotGames/29591.webp?v=1789713128032",
    },
    {
      name: "Super Ace II",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-130",
      src: "/assets/HotGames/60222.png?v=1789713128033",
    },
    {
      name: "Fortune Gems 3",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-096",
      src: "/assets/HotGames/27753.webp?v=1789713128033",
    },
    {
      name: "Circus Joker 4096",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-136",
      src: "/assets/HotGames/60206.png?v=1789713128033",
    },
    {
      name: "Money Coming",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-029",
      src: "/assets/HotGames/27751.webp?v=1789713128033",
    },
    {
      name: "Wild Bounty Showdown",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-105",
      src: "/assets/HotGames/27756.webp?v=1789713128033",
    },
    {
      name: "Treasures of Aztec",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-058",
      src: "/assets/HotGames/60221.png?v=1789713128034",
    },
    {
      name: "Magic Ace Wild Lock",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-127",
      src: "/assets/HotGames/27724.webp?v=1789713128034",
    },
    {
      name: "Aviator",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-001",
      src: "/assets/HotGames/27747.webp?v=1789713128038",
    },
    {
      name: "HEYVIP Crash",
      platFormCode: "JJ",
      casinoType: "JJ-TABLE-044",

      gameType: "TABLE",
      src: "/assets/HotGames/27746.webp?v=1789713128038",
    },
    {
      name: "FlyX",
      platFormCode: "MG",
      casinoType: "MG-EGAME-001",

      gameType: "EGAME",
      src: "/assets/HotGames/59745.png?v=1789713128038",
    },
    {
      name: "High Flyer",
      gameType: "EGAME",
      casinoType: "PP-EGAME-008",

      platFormCode: "PP",
      src: "/assets/HotGames/60524.png?v=1789713128039",
    },
    {
      name: "Crazy Time",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-006",
      src: "/assets/HotGames/27752.webp?v=1789713128039",
    },
    {
      name: "Sexy Baccarat",
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-001",
      src: "/assets/HotGames/41422.webp?v=1789713128039",
    },
    {
      name: "Bac Bo",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-172",
      src: "/assets/HotGames/60207.png?v=1789713128039",
    },
    {
      name: "Dragon Gems 500",
      platFormCode: "YESBINGO",
      gameType: "SLOT",
      casinoType: "YesBingo-SLOT-054",
      src: "/assets/HotGames/163908.png?v=1789713128040",
    },
    {
      name: "Super Elements 2",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-066",
      src: "/assets/HotGames/63458.png?v=1789713128040",
    },
    {
      name: "HEYVIP Super Elements",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-033",
      src: "/assets/HotGames/29590.webp?v=1789713128040",
    },

    {
      name: "Gates of Olympus POP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-002",

      platFormCode: "PP",
      src: "/assets/HotGames/165261.png?v=1789713128041",
    },
    {
      name: "Fortune Ace Super Scatter",
      gameType: "SLOT",
      casinoType: "PP-SLOT-598",

      platFormCode: "PP",
      src: "/assets/HotGames/60520.png?v=1789713128041",
    },
    {
      name: "Sweet Bonanza Candyland",
      gameType: "LIVE",
      casinoType: "PP-LIVE-044",

      platFormCode: "PP",
      src: "/assets/HotGames/60541.png?v=1789713128041",
    },
  ],
  sports: [
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKET",
      name: "starbaji",
      src: "/assets/Platform/icon-9w-cricket.png",
      alt: "icon-9w-cricket",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Velki",
      src: "/assets/Icon/velki-favicon.ico",
      alt: "icon-cricket",
    },

    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Sportsbook",
      src: "/assets/NewIcon/darkIcon.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "BTI",
      src: "/assets/NewIcon/provider-sbtech.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "InSports",
      src: "/assets/NewIcon/provider-awcv2_insports.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "CMD",
      src: "/assets/NewIcon/provider-cmd.png",
      alt: "icon-cricket",
      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "Pinnacle",
      src: "/assets/NewIcon/provider-awcv2_pinnacle.png",
      alt: "icon-cricket",
      gameType: "SPORTS",
      casinoType: "PINNACLE-SPORTS-001",
      platFormCode: "PINNACLE",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "HorseBook",
      src: "/assets/NewIcon/icon-horsebook.png",
      alt: "icon-cricket",
      gameType: "LIVE",
      casinoType: "HRB-LIVE-001",
      platFormCode: "HORSEBOOK",
    },
    {
      categoryType: "GAME",
      gameType: 4,
      vendorCode: "CRICKETV2",
      name: "SBO",
      src: "/assets/NewIcon/provider-sbov2.png",
      alt: "icon-cricket",

      gameType: "VIRTUAL",
      casinoType: "SABA-VIRTUAL-001",
      platFormCode: "SABA",
    },
  ],
  casino: [
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "EVOLUTION",
      name: "EVO",
      src: "../assets/Platform/provider-evo.png",
      alt: "provider-awcv2_evolution",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "SEXYBCRT",
      name: "SEXY",
      src: "../assets/Platform/provider-awcmsexy.png",
      alt: "provider-awcmsexy",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "PT",
      name: "PT",
      src: "../assets/Platform/provider-awcmpt.png",
      alt: "provider-awcmpt",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "DREAMGAMING",
      name: "DG",
      src: "../assets/Platform/provider-awcmdg.png",
      alt: "provider-awcmdg",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "HOTROAD",
      name: "HotRoad",
      src: "../assets/Platform/provider-awcmhotroad.png",
      alt: "provider-awcv2_hotroad",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "VIACASINO",
      name: "VIA",
      src: "../assets/Platform/provider-awcmvia.png",
      alt: "provider-awcmvia",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "CREEDROOMZ",
      name: "CreedRoomz",
      src: "../assets/Platform/provider-awcv2_creedroomz.png",
      alt: "provider-awcv2_creedroomz",
    },
    {
      categoryType: "VENDOR",
      gameType: 2,
      vendor: "WINFINITY",
      name: "WINFINITY",
      src: "../assets/Platform/provider-awcv2_winfinity.png",
      alt: "provider-awcv2_winfinity",
    },
  ],
  slots: [
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PG",
      name: "PG",
      src: "../assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "SPADE",
      name: "SG",
      src: "../assets/Platform/provider-awcmsg.png",
      alt: "provider-awcmsg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "FASTSPIN",
      name: "FASTSPIN",
      src: "../assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmfastspin",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "../assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "BTG",
      name: "BTG",
      src: "../assets/Platform/provider-awcv2_btg.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_btg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "NLC",
      name: "NLC",
      src: "../assets/Platform/provider-awcv2_nlc.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_nlc",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "DRAGOONSOFT",
      name: "Dragoonsoft",
      src: "../assets/Platform/provider-awcv2_dragoonsoft.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_dragoonsoft",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "RT",
      name: "RT",
      src: "../assets/Platform/provider-awcmrt.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmrt",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PT",
      name: "PT",
      src: "../assets/Platform/provider-awcmpt.png",
      alt: "provider-awcmpt",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "NETENT",
      name: "NETENT",
      src: "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
      alt: "provider-netent",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PLAY8",
      name: "P8",
      src: "../assets/Platform/provider-awcmp8.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmp8",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "Joker",
      name: "Joker",
      src: "../assets/Platform/provider-joker.png?v=1772072361392&source=mcdsrc",
      alt: "provider-joker",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "PLAYNGO",
      name: "PNG",
      src: "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-playngo",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "CG",
      name: "CG",
      src: "../assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "YL",
      name: "YL",
      src: "../assets/Platform/yl.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "OCTOPLAY",
      name: "OCTOPLAY",
      src: "../assets/Platform/provider-awcv2_octoplay.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_octoplay",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "ACEWIN",
      name: "ACEWiN",
      src: "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_acewin",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "HACKSAW",
      name: "HACKSAW",
      src: "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_hacksaw",
    },
    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "JJ",
      name: "JJ",
      src: "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_jj",
    },

    {
      categoryType: "VENDOR",
      gameType: 1,
      vendor: "YGGDRASIL",
      name: "YGGDRASIL",
      src: "../assets/Platform/provider-awcv2_yggdrasil.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yggdrasil",
    },
  ],
  crash: [
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "SPRIBE",
      name: "JDBASPRIBE",
      src: "../assets/Platform/provider-jdbaspribe.png?v=1772072361392&source=mcdsrc",
      alt: "provider-jdbaspribe",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },

    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "CG",
      name: "CG",
      src: "../assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "YL",
      name: "YL",
      src: "../assets/Platform/darkIcon.png",
    },

    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 8192,
      vendor: "CRASH88",
      name: "CRASH88",
      src: "../assets/Platform/provider-awcv2_crash88.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_crash88",
    },
  ],
  table: [
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 256,
    //   vendor: "RICH88",
    //   name: "RICH88",
    //   src: "../assets/Platform/provider-rich88.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-rich88",
    // },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "SPRIBE",
      name: "JDBASPRIBE",
      src: "../assets/Platform/provider-jdbaspribe.png?v=1772072361392&source=mcdsrc",
      alt: "provider-jdbaspribe",
    },

    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "NETENT",
      name: "NETENT",
      src: "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
      alt: "provider-netent",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "PT",
      name: "PT",
      src: "../assets/Platform/provider-awcmpt.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmpt",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 256,
    //   vendor: "PLAYNGO",
    //   name: "PNG",
    //   src: "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-playngo",
    // },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "PG",
      name: "PG",
      src: "../assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },

    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    {
      categoryType: "VENDOR",
      gameType: 256,
      vendor: "HACKSAW",
      name: "HACKSAW",
      src: "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_hacksaw",
    },
  ],
  fishing: [
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png?v=1770791064378",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },

    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "FASTSPIN",
      name: "FASTSPIN",
      src: "../assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmfastspin",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "SPADE",
      name: "SPADE",
      src: "../assets/Platform/provider-awcmsg.png",
      alt: "provider-awcmsg",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "../assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },

    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "ACEWIN",
      name: "ACEWiN",
      src: "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_acewin",
    },
    {
      categoryType: "VENDOR",
      gameType: 8,
      vendor: "JJ",
      name: "JJ",
      src: "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_jj",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 8,
    //   vendor: "GTF",
    //   name: "GTF",
    //   src: "../assets/Platform/provider-awcv2_gtf.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-awcv2_gtf",
    // },
  ],
  arcade: [
    // {
    //   categoryType: "VENDOR",
    //   gameType: 1024,
    //   vendor: "RICH88",
    //   name: "RICH88",
    //   src: "../assets/Platform/provider-rich88.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-rich88",
    // },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "JDB",
      name: "JDB",
      src: "../assets/Platform/jdb.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "FC",
      name: "FC",
      src: "../assets/Platform/provider-awcmfc.png",
      alt: "provider-awcmfc",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "PP",
      name: "PP",
      src: "../assets/Platform/provider-awcmpp.png",
      alt: "provider-awcmpp",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "PG",
      name: "PG",
      src: "../assets/Platform/provider-awcv2_pg.png",
      alt: "provider-awcv2_pg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },

    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "CG",
      name: "CG",
      src: "../assets/Platform/provider-awcmcg.png",
      alt: "provider-awcmcg",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "YL",
      name: "YL",
      src: "../assets/Platform/darkIcon.png",
    },
    {
      categoryType: "VENDOR",
      gameType: 1024,
      vendor: "RELAX",
      name: "RELAX",
      src: "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_relax",
    },
    // {
    //   categoryType: "VENDOR",
    //   gameType: 1024,
    //   vendor: "HACKSAW",
    //   name: "HACKSAW",
    //   src: "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
    //   alt: "provider-awcv2_hacksaw",
    // },
  ],
  lottery: [
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "JILI",
      name: "JILI",
      src: "../assets/Platform/provider-awcmjili.png",
      alt: "provider-awcmjili",
    },
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "KINGMAKER",
      name: "KM",
      src: "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcmkm",
    },
    {
      categoryType: "VENDOR",
      gameType: 64,
      vendor: "YESBINGO",
      name: "YELLOW BAT",
      src: "../assets/Platform/provider-awcv2_yesbingo.png?v=1772072361392&source=mcdsrc",
      alt: "provider-awcv2_yesbingo",
    },
  ],
};
export const HomeFooterPlatform = [
  {
    name: "saba",
    image: "/assets/Footer/provider-saba.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "jdb",
    image: "/assets/Footer/provider-jdb.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "jdbaspribe",
    image:
      "/assets/Footer/provider-jdbaspribe.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "cq9",
    image: "/assets/Footer/provider-cq9.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "pg",
    image: "/assets/Footer/provider-pg.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "evo",
    image: "/assets/Footer/provider-evo.webp?v=1772072361392&source=mcdsrc",
  },

  {
    name: "netent",
    image: "/assets/Footer/provider-netent.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "png",
    image: "/assets/Footer/provider-png.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "rich88",
    image: "/assets/Footer/provider-rich88.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "worldmatch",
    image:
      "/assets/Footer/provider-worldmatch.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmsexy",
    image:
      "/assets/Footer/provider-awcmsexy.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmrt",
    image: "/assets/Footer/provider-awcmrt.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmsg",
    image: "/assets/Footer/provider-awcmsg.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmkm",
    image: "/assets/Footer/provider-awcmkm.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmjili",
    image:
      "/assets/Footer/provider-awcmjili.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmp8",
    image: "/assets/Footer/provider-awcmp8.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmfc",
    image: "/assets/Footer/provider-awcmfc.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmhotroad",
    image:
      "/assets/Footer/provider-awcmhotroad.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpp",
    image: "/assets/Footer/provider-awcmpp.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpt",
    image: "/assets/Footer/provider-awcmpt.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "horsebook",
    image: "/assets/Footer/icon-horsebook.svg?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmfastspin",
    image:
      "/assets/Footer/provider-awcmfastspin.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmyesbingo",
    image:
      "/assets/Footer/provider-awcmyesbingo.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "sv388",
    image: "/assets/Footer/icon-sv388.svg?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcme1sport",
    image:
      "/assets/Footer/provider-awcme1sport.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmrwb",
    image: "/assets/Footer/provider-awcmrwb.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "awcmpinnacle",
    image:
      "/assets/Footer/provider-awcmpinnacle.webp?v=1772072361392&source=mcdsrc",
  },
  {
    name: "nst",
    image: "/assets/Footer/icon-nst.svg?v=1772072361392&source=mcdsrc",
  },
];
export const HomeFavourite = [
  {
    name: "HEYVIP Super Ace",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    image: "/assets/HotGames/image-367011.png",
  },

  {
    name: "Fortune Garuda 1000",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-225",
    image: "/assets/HotGames/image-384142.png",
  },
  {
    name: "Super Ace",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-027",
    image: "/assets/HotGames/image-296093.png",
  },
  {
    name: "Fortune Garuda 500",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-193",
    image: "/assets/HotGames/image-348494.png",
  },
  {
    name: "Super Ace Deluxe",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
    image: "/assets/HotGames/image-296113.png",
  },
  {
    name: "Wild Bounty Showdown",
    platFormCode: "PG",
    gameType: "SLOT",
    casinoType: "PG-SLOT-105",
    image: "/assets/HotGames/image-296115.png",
  },
  {
    name: "Boxing King",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-031",
    image: "/assets/HotGames/image-296097.png",
  },
  {
    name: "Fortune Gems 500",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-138",
    image: "/assets/HotGames/image-274298.png",
  },
  {
    name: "SUPER ELEMENTS",
    platFormCode: "FC",
    gameType: "SLOT",
    casinoType: "FC-SLOT-033",
    image: "/assets/HotGames/image-291736.png",
  },
  {
    name: "Magic Ace WILD LOCK",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-127",
    image: "/assets/HotGames/image-274282.png",
  },
];
// export const HomeFavourite = [
//   {
//     categoryType: "GAME",
//     gameType: 1,
//     vendorCode: "JILI",
//     name: "Super Ace",
//     platFormCode: "JILI",
//     gameType: "SLOT",
//     casinoType: "JILI-SLOT-027",
//     image: "/assets/HotGames/darkIcon (12).webp",
//   },
//   {
//     categoryType: "GAME",
//     gameType: 8192,
//     vendorCode: "JILI",
//     name: "Aviator",
//     platFormCode: "SPRIBE",
//     gameType: "EGAME",
//     casinoType: "SPRIBE-EGAME-001",
//     image: "/assets/HotGames/aviator.webp",
//   },
//   {
//     platFormCode: "JILI",
//     gameType: "SLOT",
//     casinoType: "JILI-SLOT-102",
//     name: "Super Ace Deluxe",
//     image: "/assets/HotGames/JILI-SLOT-102.webp",
//   },
//   {
//     platFormCode: "JILI",
//     gameType: "SLOT",
//     casinoType: "JILI-SLOT-043",
//     name: "Fortune Gems 500",
//     image: "/assets/HotGames/JILI-SLOT-138.webp",
//   },
//   {
//     categoryType: "GAME",
//     gameType: 1,
//     vendorCode: "PG",
//     platFormCode: "PG",
//     gameType: "SLOT",
//     casinoType: "PG-SLOT-105",
//     name: "Wild Bounty Showdown",
//     image: "/assets/HotGames/darkIcon (9).webp",
//   },
//   {
//     categoryType: "GAME",
//     gameType: 1,
//     vendorCode: "JDB",
//     platFormCode: "JDB",
//     gameType: "SLOT",
//     casinoType: "JDB-SLOT-127",
//     name: "Magic Ace WILD LOCK",
//     image: "/assets/HotGames/darkIcon (15).webp",
//   },

//   {
//     name: "Lucky Jaguar 500",
//     image: "/assets/HotGames/JILI-SLOT-160.webp",
//     platFormCode: "JILI",
//     gameType: "SLOT",
//     casinoType: "JILI-SLOT-115",
//   },
//   {
//     gameType: "SLOT",
//     casinoType: "PP-SLOT-612",
//     platFormCode: "PP",
//     name: "Big Bass Christmas - Frozen Lake",
//     image: "/assets/HotGames/PP-SLOT-612.Big Bass Christmas - Frozen Lake.webp",
//   },
//   {
//     platFormCode: "JILI",
//     gameType: "SLOT",
//     casinoType: "JILI-SLOT-142",
//     name: "Super Ace Speed Exclusive",
//     image: "/assets/HotGames/JILI-SLOT-151.webp",
//   },

//   {
//     gameType: "SLOT",
//     casinoType: "PP-SLOT-602",
//     platFormCode: "PP",
//     name: "Mermaid's Treasure Trove",
//     image: "/assets/HotGames/PP-SLOT-602.Mermaid_s Treasure Trove.webp",
//   },
// ];
export const filtercasion = [
  {
    name: "PT",
    image: "../assets/Platform/provider-awcmpt.png",
  },
  {
    name: "VIACASINO",
    image: "../assets/Platform/provider-awcmvia.png",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "EVOLUTION",
    image: "../assets/Platform/provider-evo.png",
  },
  {
    name: "SEXYBCRT",
    image: "../assets/Platform/provider-awcmsexy.png",
  },
  {
    name: "HOTROAD",
    image: "../assets/Platform/provider-awcmhotroad.png",
  },
  {
    name: "DREAMGAMING",
    image: "../assets/Platform/provider-awcmdg.png",
  },
  {
    name: "CREEDROOMZ",
    image: "../assets/Platform/provider-awcv2_creedroomz.png",
  },
  {
    name: "WINFINITY",
    image: "../assets/Platform/provider-awcv2_winfinity.png",
  },
];

export const filterslot = [
  {
    name: "PG",
    image: "../assets/Platform/provider-awcv2_pg.png",
  },
  {
    name: "CG",
    image: "../assets/Platform/provider-awcmcg.png",
  },

  {
    name: "DRAGOONSOFT",
    image: "../assets/Platform/provider-dragoonsoft.png",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "PT",
    image: "../assets/Platform/provider-awcmpt.png",
  },
  {
    name: "KINGMAKER",
    image:
      "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "RT",
    image: "../assets/Platform/provider-awcmrt.png",
  },
  {
    name: "BTG",
    image:
      "../assets/Platform/provider-awcv2_btg.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JILI",
    image: "../assets/Platform/provider-awcmjili.png",
  },
  {
    name: "NETENT",
    image:
      "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JDB",
    image: "../assets/Platform/provider-jdb.png",
  },
  {
    name: "FC",
    image: "../assets/Platform/provider-awcmfc.png",
  },
  {
    name: "NLC",
    image: "../assets/Platform/provider-nlc.png",
  },
  {
    name: "FASTSPIN",
    image: "../assets/Platform/provider-awcmfastspin.png",
  },
  {
    name: "YGGDRASIL",
    image:
      "../assets/Platform/provider-awcv2_yggdrasil.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "SPADE",
    image: "../assets/Platform/provider-awcmsg.png",
  },
  {
    name: "JJ",
    image:
      "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "Joker",
    image: "../assets/Platform/provider-joker.png",
  },
  {
    name: "OCTOPLAY",
    image: "../assets/Platform/provider-awcv2_octoplay.png",
  },
  {
    name: "PLAYNGO",
    image:
      "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  },

  {
    name: "ACEWIN",
    image:
      "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "PLAY8",
    image: "../assets/Platform/provider-awcmp8.png",
  },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "YESBINGO",
    image: "../assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "YL",
    image: "../assets/Platform/yl.png",
  },
];

export const filtertable = [
  {
    image: "../assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },
  {
    name: "HACKSAW",
    image:
      "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  },
  {
    image: "../assets/Platform/provider-awcmkm.png",
    name: "KINGMAKER",
  },
  {
    name: "NETENT",
    image:
      "../assets/Platform/provider-netent.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "PT",
    image: "../assets/Platform/provider-awcmpt.png",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   image: "../assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
  {
    name: "PG",
    image: "../assets/Platform/provider-awcv2_pg.png",
  },
  {
    image: "../assets/Platform/provider-jdbaspribe.png",
    name: "SPRIBE",
  },
];

export const filtercrash = [
  {
    image: "../assets/Platform/provider-jdbaspribe.png",
    name: "SPRIBE",
  },
  {
    name: "JDB",
    image: "../assets/Platform/provider-jdb.png",
  },
  {
    name: "YL",
    image: "../assets/Platform/yl.png",
  },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  {
    image: "../assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "CG",
    image: "../assets/Platform/provider-awcmcg.png",
  },
  // {
  //   image: "../assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
  // {
  //   name: "Joker",
  //   image: "../assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "SMARTSOFT",
  //   image:
  //     "../assets/Platform/provider-awcv2_smartsoft.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "../assets/Platform/provider-awcmkm.png",
    name: "KINGMAKER",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "../assets/Platform/provider-awcmfc.png",
    name: "FC",
  },
  {
    image:
      "../assets/Platform/provider-awcv2_crash88.png?v=1772072361392&source=mcdsrc",
    name: "CRASH88",
  },
];

export const filterfishing = [
  {
    name: "JILI",
    image: "../assets/Platform/provider-awcmjili.png",
  },
  {
    name: "SPADE",
    image: "../assets/Platform/provider-awcmsg.png",
  },
  {
    name: "FC",
    image: "../assets/Platform/provider-awcmfc.png",
  },
  {
    name: "YESBINGO",
    image: "../assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "ACEWIN",
    image:
      "../assets/Platform/provider-awcv2_acewin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JDB",
    image: "../assets/Platform/provider-jdb.png",
  },
  {
    name: "FASTSPIN",
    image:
      "../assets/Platform/provider-awcmfastspin.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "JJ",
    image:
      "../assets/Platform/provider-awcv2_jj.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   name: "JOKER",
  //   image: "../assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "GTF",
  //   image:
  //     "../assets/Platform/provider-awcv2_gtf.png?v=1772072361392&source=mcdsrc",
  // },
];

export const filterarcade = [
  {
    image: "../assets/Platform/provider-awcv2_pg.png",
    name: "PG",
  },
  {
    name: "JILI",
    image: "../assets/Platform/provider-awcmjili.png",
  },
  {
    name: "PP",
    image: "../assets/Platform/provider-awcmpp.png",
  },
  {
    name: "KINGMAKER",
    image:
      "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  {
    name: "CG",
    image: "../assets/Platform/provider-awcmcg.png",
  },
  {
    image: "../assets/Platform/provider-jdb.png",
    name: "JDB",
  },
  {
    image: "../assets/Platform/provider-awcmfc.png",
    name: "FC",
  },
  // {
  //   name: "HACKSAW",
  //   image:
  //     "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  // },
  {
    image: "../assets/Platform/provider-awcmyl.png",
    name: "YL",
  },
  {
    name: "RELAX",
    image:
      "../assets/Platform/provider-awcv2_relax.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   image: "../assets/Platform/provider-rich88.png",
  //   name: "RICH88",
  // },
];

export const filterlotto = [
  {
    image: "../assets/Platform/provider-awcmjili.png",
    name: "JILI",
  },

  {
    name: "YESBINGO",
    image: "../assets/Platform/provider-awcmyesbingo.png",
  },
  {
    name: "KINGMAKER",
    image:
      "../assets/Platform/provider-awcmkm.png?v=1772072361392&source=mcdsrc",
  },
  // {
  //   name: "PLAYNGO",
  //   image:
  //     "../assets/Platform/provider-playngo.png?v=1772072361392&source=mcdsrc",
  // },
  // {
  //   name: "HACKSAW",
  //   image:
  //     "../assets/Platform/provider-awcv2_hacksaw.png?v=1772072361392&source=mcdsrc",
  // },
  // {
  //   name: "Joker",
  //   image: "../assets/Platform/provider-joker.png",
  // },
  // {
  //   name: "RICH88",
  //   image: "../assets/Platform/provider-rich88.png",
  // },
];

export const HomeIcon = {
  sports: `../assets/Icon/icon-sport.png`,
  casino: "../assets/Icon/icon-casino.png",
  slots: "../assets/Icon/icon-slot.png",
  table: "../assets/Icon/icon-table.png",
  crash: "../assets/Icon/icon-crash.png",
  fishing: "../assets/Icon/icon-fish.png",
  arcade: "../assets/Icon/icon-arcade.png",
  lotto: "../assets/Icon/icon-lottery.png",
};
